import { Messages } from '../../codegen/Localize';
import {
  ActionHelpers, standardActionErrorMsg,
  standardActionSuccessMsg
} from '../../commonInfra/contentActions/ActionHelpers';
import { IErrorItem } from '../../commonInfra/contentActions/MultipleItemResult';
import { ViewErrors } from '../../content/services/ViewErrors';
import { Views } from '../../views/resources/Views';
import { IActionContext } from '../helpers/ActionContext';
import { L10n } from '../L10n/L10n';
import { IViewDetailInfo, IViewInfo } from '../models/IViewInfo';
import { IWorkbookParentInfo } from '../models/IWorkbookInfo';
import { Set } from '../models/Set';
import { Module } from '../Module';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { ConfirmActionDialog } from './ConfirmActionDialog';

interface IConfirmDeleteViewsScope extends ng.IScope {
    deleteViewsConfirmation: string;
    deleteWorkbooksConfirmation: string;
}

export class HideViewsAction {

  public static $inject = ['ConfirmActionDialog', '$translate'];

  constructor(
    private ConfirmActionDialog: ConfirmActionDialog,
    private $translate: ng.translate.ITranslateService,
  ) { }

  public confirmDeleteViews(views: Set<IViewInfo>, context: IActionContext): ng.IPromise<IResult> {
    const scope = <IConfirmDeleteViewsScope> context.scope;
    const workbooksToDelete = HideViewsAction.determineWorkbooksToBeDeleted(views);

    scope.deleteViewsConfirmation = this.$translate.instant('confirmDeleteViews', {
      VIEW_COUNT: views.size(),
      VIEW_NAME: L10n.elideIfLong(views.first().name)
    }, L10n.Interpolations.Count);

    scope.deleteWorkbooksConfirmation = workbooksToDelete.length > 0
      ? this.$translate.instant('confirmDeleteViewsWorkbookWarning', {
          WORKBOOK_COUNT: workbooksToDelete.length,
          WORKBOOK_NAME: L10n.elideIfLong(workbooksToDelete[0].name)
        }, L10n.Interpolations.Count)
      : null;

    return this.ConfirmActionDialog.open({
      scope: context.scope,
      title: this.$translate.instant('deleteMessage'),
      bodyTemplateUrl: 'confirmDeleteViews.html',
      actionName: this.$translate.instant('confirmDeleteButton', {
        ITEM_COUNT: views.size()
      }, L10n.Interpolations.Count),
      isDeleteAction: true,

      action: () => {
        return Views.hide(views.keys()).then(
          (result: IResult) => this.notifyResult(views, result));
      }
    }).result;
  }

  // Determine if any workbooks will be deleted as a result of deleting the selected views
  public static determineWorkbooksToBeDeleted(views: Set<IViewInfo | IViewDetailInfo>): IWorkbookParentInfo[] {
    const workbooksToDelete: IWorkbookParentInfo[] = [];
    const workbookViewCount: _.Dictionary<number> = {};
    views.each((view: IViewInfo) => {
      let viewCount = workbookViewCount[view.workbook.id] || 0;
      viewCount++;
      if (viewCount === view.workbook.numSheets) {
        workbooksToDelete.push(view.workbook);
      }
      workbookViewCount[view.workbook.id] = viewCount;
    });
    return workbooksToDelete;
  }

  private notifyResult(views: Set<IViewInfo>, result: IResult) {
    ActionHelpers.displayStandardToastsForResult(
      views,
      result,
      {
        success: standardActionSuccessMsg(Messages.deleteViewsSuccess),
        error: standardActionErrorMsg(Messages.deleteViewsError),
      },
      (errorItem: IErrorItem<IViewInfo>) => ViewErrors.errorDetailsFor(errorItem));
  }

}

Module.instance().service('HideViewsAction', HideViewsAction);
